import { render, staticRenderFns } from "./StockTransferAdmin.vue?vue&type=template&id=6b43688e&scoped=true&"
import script from "./StockTransferAdmin.vue?vue&type=script&lang=js&"
export * from "./StockTransferAdmin.vue?vue&type=script&lang=js&"
import style0 from "./StockTransferAdmin.vue?vue&type=style&index=0&id=6b43688e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b43688e",
  null
  
)

export default component.exports